import axios from 'axios'
import { ref } from 'vue'

export function useAddress() {
  const suggestions = ref([])
  const loading = ref(false)

  async function search(event: { query: string }) {
    if (!event.query || event.query.length < 3) {
      loading.value = false
      return
    }

    loading.value = true

    await axios
      .get('/address-suggestions', {
        params: {
          query: event.query,
        },
      })
      .then((response) => {
        suggestions.value = response.data || []
      })
      .catch(() => {
        suggestions.value = []
      })
      .finally(() => (loading.value = false))
  }

  return {
    suggestions,
    search,
    loading,
  }
}
